import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { LoginPage } from "./types";
import {
  StyledLoginConatainer,
  StyledImageContainer,
  StyledLoginPage,
} from "./style";

function Login({
  text = "Welcome to appcharge store!",
  textColor = "blue",
  textSize = 24,
  textWeight = "normal",
  logo = "https://media.appcharge.com/defaults/logo.svg",
  appId,
  responseFacebook,
  facebookClicked,
  width = "100vw",
  height = "100vh - 200px",
  backgroundColor = "transparent",
  fontFamily,
}: LoginPage) {
  const responseFacebookHandler = (response: any) => {
    responseFacebook(response);
  };

  const facebookClickedHandler = (callback: Function) => {
    facebookClicked(callback);
  };

  return (
    <StyledLoginPage
      fontFamily={fontFamily}
      textColor={textColor}
      textSize={textSize}
      textWeight={textWeight}
      width={width}
      height={height}
      backgroundColor={backgroundColor}
    >
      <StyledImageContainer>
        <img className='logo' alt='game logo' src={logo} />
      </StyledImageContainer>
      <h2>{text}</h2>
      <StyledLoginConatainer>
        <FacebookLogin
          appId={appId}
          callback={responseFacebookHandler}
          autoLoad={false}
          isMobile={false}
          fields='picture'
          render={(renderProps: { onClick: () => void }) => (
            <img
              className='loginButton'
              onClick={() => facebookClickedHandler(renderProps.onClick)}
              alt='facebook button'
              src='https://media.appcharge.com/defaults/facebook_login.png'
            />
          )}
        />
        <span style={{ color: "white" }}>
          By logging in you acknowledge that you have read and agree the{" "}
          <a href='./privacy'>Privacy Policy</a> And{" "}
          <a href='./tnc'>Terms and Conditions</a>
        </span>
      </StyledLoginConatainer>
    </StyledLoginPage>
  );
}

export default Login;
